import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
    {
        path: '/login',
        name: 'login',
        component: () => import('./views/Login.vue')
        // component: () => import('./views/LoginNew.vue')
    },
    {
        path: '/',
        name: 'home',
        component: () => import('./views/Home.vue'),
        children: [
            {
                path: 'albums',
                name: 'albums',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ './views/Albums.vue'),
            },
            {
                path: 'handbook',
                name: 'handbook',
                component: () => import(/* webpackChunkName: "about" */ './views/HandBook.vue'),
            },

            {
                path: 'albums/new_album',
                name: 'create_album',
                component: () => import('./views/AlbumForm.vue')
            },
            {
                path: 'albums/album_detail/album_form',
                name: 'album_form',
                component: () => import('./views/AlbumForm.vue')
            },
            {
                path: 'albums/album_detail',
                name: 'album_detail',
                component: () => import('./views/AlbumDetail.vue'),
                props: true
            },
            {
                path: 'albums/album_detail/album_info_edit',
                name: 'album_info_edit',
                component: () => import('./views/AlbumInfoEdit.vue'),
            },
            {
                path: 'albums/album_detail/sheet_detail',
                name: 'sheet_detail',
                component: () => import('./views/SheetDetail.vue')
                // component: () => import('./views/SheetDetailNew.vue')
            },
            {
                path: 'albums/album_detail/sheet_info_edit',
                name: 'sheet_info_edit',
                component: () => import('./views/SheetInfoEdit.vue')
            },
            {
                path: 'albums/album_detail/create_sheet',
                name: 'upload_sheet',
                component: () => import('./views/UploadSheet.vue'),
            },
            {
                path: 'albums/album_detail/sheet_detail/add_score',
                name: 'add_score',
                component: () => import('./views/UploadSheet.vue')
            },
            {
                path: 'albums/album_detail/sheet_detail/sheet_edit',
                name: 'edit_sheet',
                component: () => import('./views/UploadSheet.vue')
            },
            {
                path: 'albums/album_detail/create_sheet',
                name: 'create_sheet',
                component: () => import('./views/UploadSheet.vue')
            },
            {
                path: 'albums/create_sheet',
                name: 'upload_sheet_home',
                component: () => import('./views/UploadSheet.vue')
            },
            {
                path: 'albums/album_detail/sheet_detail/sheet_review_detail',
                name: 'sheet_review_detail',
                component: () => import('./views/SheetReviewDetail.vue')
            },
            {
                path: 'albums/album_detail/album_review_detail',
                name: 'album_review_detail',
                component: () => import('./views/AlbumReviewDetail.vue')
            },
            {
                path: 'albums/album_detail/sheet_detail/upload_score/sheet_show_preview',
                name: 'sheet_show_preview',
                component: () => import('./views/SheetShowPreview.vue')
            }

        ]
    }
  ]
})
